import React, { useEffect } from 'react';
import { FiGlobe } from 'react-icons/fi';
import { LANGUAGE_LABELS, SUPPORTED_LANGUAGES, useI18n } from './i18n';
import { trackEvent } from './analytics';

const languageEventCode = (language) => (
  SUPPORTED_LANGUAGES.includes(language) ? language : 'unknown'
);

export default function LanguageSelector({ compact = false }) {
  const { language, setLanguage, t } = useI18n();

  useEffect(() => {
    const code = languageEventCode(language);
    trackEvent('webapp_language_view', { language: code });
    trackEvent(`webapp_language_${code}`, { language: code });
  }, [language]);

  return (
    <label className={`ui-language-switcher ${compact ? 'compact' : ''}`}>
      <FiGlobe aria-hidden="true" />
      <span className="ui-language-switcher__label">{t('common.language')}</span>
      <select
        value={language}
        onChange={(event) => {
          const nextLanguage = event.target.value;
          const nextCode = languageEventCode(nextLanguage);
          trackEvent('language_change', {
            previous_language: language,
            language: nextCode,
          });
          trackEvent('webapp_language_change', {
            previous_language: languageEventCode(language),
            language: nextCode,
          });
          trackEvent(`webapp_language_change_${nextCode}`, {
            previous_language: languageEventCode(language),
            language: nextCode,
          });
          setLanguage(nextLanguage);
        }}
        aria-label={t('common.language')}
      >
        {SUPPORTED_LANGUAGES.map((code) => (
          <option key={code} value={code}>
            {LANGUAGE_LABELS[code]}
          </option>
        ))}
      </select>
    </label>
  );
}
